module.exports = __webpack_public_path__ + "img/groups32.d21818b3.svg";